import { useState } from "react"
import RegistrantQuestion from "./RegistrantQuestion"
import RegisterableContext from "components/admin/registerable/context"
import { StatusMessage } from "components/ui"
import { Button, StackView } from "@planningcenter/tapestry-react"
import { isBlank, isPresent } from "utils/helpers"
import { Pane } from "components/ui"
import { useContext } from "react"
import { useEffect } from "react"

const RegistrantQuestions = () => {
  const { registerable: registration } = useContext(RegisterableContext)
  const [saveStatus, setSaveStatus] = useState({})
  const [isEditing, setIsEditing] = useState(false)
  const [answers, setAnswers] = useState(registration.answers || [])

  useEffect(() => {
    setAnswers(registration.answers)
  }, [registration.answers])

  const handleIsEditing = () => {
    setSaveStatus({})
    setIsEditing(!isEditing)
  }

  const handleCancel = () => {
    setAnswers(registration.answers)
    handleIsEditing()
  }

  const handleChange = ({ target: { value, checked } }, id) => {
    const question = registration.questions.find(question => question.id === id)

    const isDropdown = question.kind === "dropdown"
    const isSingleCheckBox = question.kind === "singlecheckbox"
    const isYesNo = question.kind === "yesno"

    const answer = answers.find(answer => answer.questionId === id) || {
      questionId: id
    }

    answer.answers ||= []

    const isAnswerBlank =
      isBlank(value) || (isYesNo && value === false) || (isSingleCheckBox && !checked)

    if (isPresent(answer.id) && isAnswerBlank) {
      answer._destroy = true
    } else if (isDropdown && question.allowMultiple) {
      answer.answers = checked
        ? [...answer.answers, value]
        : answer.answers.filter(a => a !== value)

      if (answer.answers.length === 0) {
        answer._destroy = true
      }
    } else if (isSingleCheckBox) {
      answer.answers = [checked]
    } else {
      answer.answers = [value]
    }

    setAnswers([...answers.filter(answer => answer.questionId !== id), answer])
  }

  const handleSave = async () => {
    setSaveStatus({
      isFetching: true,
      text: "Saving...",
      icon: "spinner"
    })

    registration
      .update({
        answers_attributes: answers.map(({ id, answers, questionId: question_id, _destroy }) => ({
          id,
          answers,
          question_id,
          _destroy
        }))
      })
      .then(() => {
        setSaveStatus({
          isFetching: false,
          text: "Saved!",
          icon: "general#check",
          type: "success"
        })
        handleIsEditing()
      })
      .catch(() => {
        setSaveStatus({
          isFetching: false,
          text: "Error saving changes.",
          icon: "general#x",
          type: "error"
        })

        setTimeout(() => setSaveStatus({}), 3000)
      })
  }

  return (
    <Pane marginBottom={1}>
      <Pane.Header>
        <Pane.Title>Registration questions</Pane.Title>

        {isEditing ? (
          <StackView axis="horizontal">
            {isPresent(saveStatus) && <StatusMessage {...saveStatus} />}
            <Button
              title="Cancel"
              size="xs"
              variant="outline"
              marginHorizontal={1}
              disabled={saveStatus.isFetching}
              onClick={handleCancel}
            />
            <Button
              title="Save"
              size="xs"
              theme="create"
              disabled={saveStatus.isFetching}
              onClick={handleSave}
            />
          </StackView>
        ) : (
          <Button title="Edit" size="xs" variant="outline" onClick={handleIsEditing} />
        )}
      </Pane.Header>
      <Pane.Body>
        {registration.questions.map(question => (
          <RegistrantQuestion
            key={question.id}
            isEditing={isEditing}
            question={question}
            answer={answers.find(({ questionId }) => questionId === question.id)}
            onChange={handleChange}
          />
        ))}
      </Pane.Body>
    </Pane>
  )
}

export default RegistrantQuestions
